<template>
  <v-app>
    <Appbar />
    <v-main>
      <Information />
      <v-card
        :tile="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs"
        class="mb-10 mt-4  mx-auto fill-width"
        flat
        max-width="640"
      >
        <v-card-title class="text-center pa-8">
          <h4 class="fill-width">
            プレミアムプラン契約状況
          </h4>
        </v-card-title>
        <div
          v-if="response"
          class="px-6"
        >
          <v-simple-table>
            <template v-slot:default>
              <tbody>
                <!--<tr>-->
                <!--<td>プラン</td>-->
                <!--<td>{{response.product_name}} {{response.plan}}</td>-->
                <!--</tr>-->
                <tr>
                  <td>開始日</td>
                  <td>{{ response.start_date }}</td>
                </tr>
                <tr v-if="response.trialEnd">
                  <td>トライアル期間終了</td>
                  <td>{{ response.trialEnd }}</td>
                </tr>
                <tr>
                  <td>次回更新日</td>
                  <td>
                    {{
                      response.cancelled ? `キャンセル済み　${response.checkout_date}まで有効` :
                      response.checkout_date
                    }}
                  </td>
                </tr>
                <tr>
                  <td valign="top">
                    <div class="mt-2" />
                  </td>
                  <td>
                    <div class="mt-2">
                      <div class="d-flex">
                        小計<p class="ml-auto ma-0">
                          ¥{{ response.price }}
                        </p>
                      </div>
                      <div
                        v-if="response.coupon"
                        class="d-flex"
                      >
                        <p
                          class="ma-0"
                          style="color: gray"
                        >
                          {{ response.coupon.name }}({{ response.coupon.percent_off }}%割引)
                        </p><p class="ml-auto ma-0">
                          - ¥{{ response.price * (response.coupon.percent_off/100) }}
                        </p>
                      </div>
                      <div class="d-flex">
                        合計<p class="ml-auto ma-0">
                          ¥{{ response.price - (response.coupon ? response.price * (response.coupon.percent_off/100) : 0) }}
                        </p>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <div class="mx-auto mt-4">
            <h5>プラン</h5>
            <v-row
              class="pa-4"
              justify="center"
            >
              <v-col
                cols="12"
                sm="8"
                md="6"
                lg="4"
                xl="3"
              >
                <selectable-plan
                  v-model="selectPlan"
                  plan-detail-name="月払い"
                  plan-name="month"
                  plan-gigs="　"
                  plan-dollars="250円 / 月"
                  :is-agreement="isMonthAgreement"
                />
              </v-col>
              <v-col
                cols="12"
                sm="8"
                md="6"
                lg="4"
                xl="3"
              >
                <selectable-plan
                  v-model="selectPlan"
                  plan-detail-name="年払い"
                  plan-name="year"
                  plan-gigs="(２ヶ月分お得！)"
                  plan-dollars="2500円 / 年"
                  :is-agreement="isYearAgreement"
                />
              </v-col>
            </v-row>
            <h5 class="mt-6 mb-3">
              クレジットカード情報
            </h5>
            <CardInput
              @changeCard="onChangeCard"
            />
          </div>

          <v-card-actions>
            <v-spacer />
            <v-btn
              v-if="!response.cancelled"
              :disabled="agreementSelectPlan === selectPlan"
              :loading="saving"
              class="mt-4 px-8"
              color="accent"
              @click="showConfirm()"
            >
              プラン変更
            </v-btn>
            <v-btn
              v-if="response.cancelled"
              :disabled="!selectPlan"
              :loading="saving"
              class="mt-4 px-8"
              color="accent"
              @click="showConfirm()"
            >
              確認
            </v-btn>
            <v-spacer />
          </v-card-actions>

          <v-card-actions class="pt-5 pb-5">
            <v-btn
              color="accent"
              @click="invoiceDialog = true"
            >
              支払い履歴
            </v-btn>
            <v-spacer />
            <v-btn
              v-if="!response.cancelled"
              color="red"
              outlined
              @click="cancelConfirm = true"
            >
              このプランを解約する
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-main>
    <Footer
      :accent-color="accentColor"
      :sub-primary-color="subPrimaryColor"
    />

    <v-dialog
      v-if="response"
      v-model="confirmDialog"
      max-width="450"
    >
      <v-card class="mx-auto">
        <v-card-title>
          決済確認
        </v-card-title>

        <v-card-subtitle class="mt-3">
          <ul>
            <li>プラン：{{ selectPlan == "month" ? '月払い' : '年払い' }}</li>
            <li>料金：{{ selectPlan == "month" ? '80円 / 月' : '760円 / 年' }}</li>
            <li>カードNo：XXXX-XXXX-XXXX-{{ cardObject ? cardObject.last4 : '' }}</li>
            <li>有効期限：{{ cardObject ? `${cardObject.year}/${cardObject.month}` : '' }}</li>
          </ul>
        </v-card-subtitle>

        <v-card-actions>
          <v-list-item class="grow">
            <v-row
              align="center"
              justify="end"
            >
              <v-btn
                text
                @click="onClickCancel"
              >
                キャンセル
              </v-btn>

              <v-btn
                text
                @click="startCheckout()"
              >
                完了
              </v-btn>
            </v-row>
          </v-list-item>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="response"
      v-model="cancelConfirm"
      max-width="450"
    >
      <v-card class="mx-auto">
        <v-card-title>
          プラン解約確認
        </v-card-title>

        <v-card-subtitle class="mt-3">
          <ul>
            <li>プラン：{{ agreementSelectPlan == "month" ? '月払い' : '年払い' }}</li>
            <li>料金：{{ agreementSelectPlan == "month" ? '80円 / 月' : '760円 / 年' }}</li>
            <li>カードNo：XXXX-XXXX-XXXX-{{ cardObject ? cardObject.last4 : '' }}</li>
            <li>有効期限：{{ cardObject ? `${cardObject.year}/${cardObject.month}` : '' }}</li>
          </ul>
        </v-card-subtitle>

        <v-card-actions>
          <v-list-item class="grow">
            <v-row
              align="center"
              justify="end"
            >
              <v-btn
                text
                @click="cancelConfirm = false"
              >
                キャンセル
              </v-btn>

              <v-btn
                text
                @click="cancel()"
              >
                完了
              </v-btn>
            </v-row>
          </v-list-item>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="response"
      v-model="invoiceDialog"
      max-width="450"
    >
      <v-card class="mx-auto">
        <v-card-title>
          支払い履歴
        </v-card-title>

        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  日付
                </th>
                <th class="text-left">
                  タイトル
                </th>
                <th class="text-left">
                  金額
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(invoice, index) in response.invoiceList"
                :key="'invoice_' + index"
                @click="onClickInvoice(invoice)"
              >
                <td>{{ invoice.date }}</td>
                <td>{{ invoice.name }}</td>
                <td>¥{{ invoice.price }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>

        <v-card-actions>
          <v-list-item class="grow">
            <v-row
              align="center"
              justify="end"
            >
              <v-btn
                text
                @click="invoiceDialog = false"
              >
                閉じる
              </v-btn>
            </v-row>
          </v-list-item>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
  import axios from "axios";
  import config from "@/const"
  import firebase from "firebase";
  import Information from '../component/Information.vue';
  import Footer from '../component/Footer.vue';
  import SelectablePlan from '@/component/SelectablePlan.vue';
  import Appbar from '../component/Appbar.vue';
  import {mapState} from "vuex";
  import CardInput from '@/component/CardInput.vue'

  export default {
    name: "Payments",
    components: {
      Appbar,
      Footer,
      Information,
      SelectablePlan,
      CardInput
    },
    data() {
      return {
        accentColor: null,
        subPrimaryColor: null,
        agreementSelectPlan: null,
        invoiceDialog: false,
        selectPlan: null,
        response: null,
        isMonthAgreement: false,
        isYearAgreement: false,
        saving: false,
        confirmDialog: false,
        complete: false,
        cardObject: null,
        cancelConfirm:false
      }
    },
    computed: {
      ...mapState({
        user: state => state.userModule.user,
      })
    },
    mounted() {
      this.accentColor = this.$vuetify.theme.themes.light.secondary
      const primary = this.$vuetify.theme.themes.light.primary
      const red = parseInt(primary.substring(1, 3), 16);
      const green = parseInt(primary.substring(3, 5), 16);
      const blue = parseInt(primary.substring(5, 7), 16);
      this.subPrimaryColor = "#" + (red + 37).toString(16) + (green + 24).toString(16) + (blue + 9).toString(16)
      this.execute();
    },
    methods: {
      async execute() {
        const user = firebase.auth().currentUser;
        this.userToken = await user.getIdToken(false);
        axios.get(config.API_URL + "auth/checkout", {
          headers: {"X-Firebase-Auth": this.userToken},
          params:{
            canceled: true
          }
        }).then(value => {
          this.response = value.data;
          if(!this.response.cancelled){
            this.isYearAgreement = this.response.id === config.PURCHASE_YEARY_ID;
            this.isMonthAgreement = this.response.id === config.PURCHASE_MONTHLY_ID;
            this.selectPlan = this.isYearAgreement ? 'year' : 'month';
            this.agreementSelectPlan = this.selectPlan;
          }
        }).catch(err => {
        });
      },
      showConfirm() {
        this.saving = true;
        this.confirmDialog = true
      },
      onClickCancel() {
        this.confirmDialog = false;
        this.saving = false;
      },
      checkout(token){
        const planId = this.selectPlan == "month" ? config.PURCHASE_MONTHLY_ID : config.PURCHASE_YEARY_ID;
        axios.post(config.API_URL + "auth/checkout", {
          stripeToken: this.cardObject.id,
          planId: planId,
          coupon:""
        }, {
          headers: {"X-Firebase-Auth": token},
        }).then(response => {
          this.$store.dispatch("userModule/replaceUser", {ret: response})
          this.saving = false
          this.$router.push("/payments")
          this.execute();
          this.onClickCancel();
        }).catch(reason => {
          if (reason.response.status === 400) {
            const message = reason["response"]["data"]["message"];
            if (message.match("incorrect_cvc")) {
              alert("セキュリティコードが間違っています。")
            } else if (message.match("incorrect_expiry")) {
              alert("有効期限が間違っています。")
            } else if (message.match("processing_error")) {
              alert("処理中にエラーが発生しました。")
            } else if (message.match("incorrect_number")) {
              alert("カード番号が不正です。")
            } else if (message.match("This promotion code cannot be redeemed")) {
              alert("初めての決済でのみ利用可能なプロモーションコードです。")
            } else {
              alert("カード決済に失敗しました。")
            }
          } else {
            alert("しばらく待ってから再度お試しください。")
          }
          this.onClickCancel();
        })
      },
      startCheckout(){
        const user = firebase.auth().currentUser;
        user.getIdToken(false).then(token => {
          if(this.response.cancelled){
            this.checkout(token);
          } else{
            this.executePlanChange(token);
          }
        }).catch(() => {
          alert("ユーザー認証でエラーが発生しました。画面をリロードしてお試しください")
          this.onClickCancel();
        });
      },
      executePlanChange(token) {
        const id = this.selectPlan === 'year' ? config.PURCHASE_YEARY_ID : config.PURCHASE_MONTHLY_ID;
        axios.patch(`${config.API_URL}auth/subscriptions/${id}`, {},
        {
          headers: {"X-Firebase-Auth": token},
        }).then(value => {
            this.execute();
            this.onClickCancel();
        })
      },
      /**
       * Subscriptionのキャンセル
       */
      cancel() {
        this.cancelConfirm = true;
        const user = firebase.auth().currentUser;
        user.getIdToken(false).then(token => {
          axios.delete(config.API_URL + `auth/subscriptions/${this.response.id}`, {headers: {"X-Firebase-Auth": token},}).then((response) => {
            this.execute();
            this.cancelConfirm = false;
            // this.$router.push("/input-card")
            this.isYearAgreement = false;
            this.isMonthAgreement = false;
            this.selectPlan = null;
            this.agreementSelectPlan = null;
          }).catch(() => {
            this.cancelConfirm = false;
            alert("解約処理中にエラーが発生しました。再度お試しいただいても改善しない場合はお問い合わせよりご連絡ください。")
          })
        }).catch(reason => {
          this.cancelConfirm = false;
          alert("ユーザー認証でエラーが発生しました。画面をリロードしてお試しください")
        })
      },
      onClickInvoice(invoice) {
        window.open(invoice.invoice_url, '_blank');
      },
      onChangeCard(card) {
        this.cardObject = card;
      }
    },
  }
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Josefin+Sans&display=swap');

    h5 {
        border-left: 5px solid var(--v-secondary-base);
        clear: both;
        padding: 5px 0 5px 15px;
        text-align: left;
        color: #000000;
        font-size: 16px;
    }
</style>
